import './index.scss'
import '../base.css'

import { Toast } from 'vant'

export default function WarnToast (message: string, duration = 2000, onClose?:Function) {
  const ins = Toast({
    duration,
    message,
    className: 'warn-toast',
    icon: require('@/assets/images/ic_add_c@2x.png'),
    // @ts-ignore
    onClose: onClose,
  })

  return ins.close as () => void
}
